import React, { useRef } from 'react';
import { Column, DataGrid, HeaderFilter, Paging, Scrolling, Selection, FilterRow, Export, SearchPanel, Summary, TotalItem } from 'devextreme-react/data-grid';
import { encryptText, convertUTCDateToLocalDate, onExporting, toConvertedDate, getDateFilter, setDxFilterPlaceholder } from '../../../../utils/util';
import { IJob } from '../../../../interfaces/Job';
import { JobStatusType } from '../../../../enums/JobEnum';
import { useHistory } from 'react-router-dom';
import ViewButton from '../../../../umut-components/Buttons/ViewButton';
import EmptyTable from '../../../../umut-components/Icons/EmptyTable';
import config from '../../../../config/config.json';

type Props = {
    data: IJob[]
}

const JobTable: React.FC<Props> = ({ data }) => {
    const history = useHistory();
    const tableRef = useRef<DataGrid>(null)

    const displayStatusType = (cellData: any) => {
        const jobStatusType = cellData?.data?.jobStatusTypeName;
        return (<strong className={`text-${jobStatusType === JobStatusType.COMPLETED ? "success" : jobStatusType === JobStatusType.PENDING ? "warning" : "danger"}`}>{jobStatusType === "Started" ? "In Progress" : jobStatusType}</strong>)
    }

    const calculateScheduledStart = (cellValue: any) => {
        return toConvertedDate(cellValue.scheduledStart, cellValue.hostPropertyCityTimeZone);
    }

    const calculateStartedOn = (cellValue: any) => {
        return toConvertedDate(cellValue.startedOn, cellValue.hostPropertyCityTimeZone);
    }

    const calculateCleaningPeriodStart = (cellValue: any) => {
        return toConvertedDate(cellValue.cleaningPeriodStart, cellValue.hostPropertyCityTimeZone);
    }

    const calculateScheduledFinish = (cellValue: any) => {
        return toConvertedDate(cellValue.scheduledFinish, cellValue.hostPropertyCityTimeZone);
    }


    const calculateFinishedOn = (cellValue: any) => {
        return toConvertedDate(cellValue.finishedOn, cellValue.hostPropertyCityTimeZone);
    }

    const calculateCleaningPeriodEnd = (cellValue: any) => {
        return toConvertedDate(cellValue.cleaningPeriodEnd, cellValue.hostPropertyCityTimeZone);
    }

    const displayEditButton = (cellData: any) => {
        return (
            <ViewButton iconWidth="20" iconHeight="20" viewFn={() => { history.push('/job-details/' + encryptText(cellData?.data?.id)) }} />
        )
    }
    const toJobDetail = (cellData: any) => {
        if (cellData?.data?.id) {
            // history.push('/job-details/' + encryptText(cellData?.data?.id))
            window.open('/job-details/' + encryptText(cellData?.data?.id))
        }
    }

    if (data?.length === 0) {
        return <EmptyTable title='No Jobs' />
    }

    return (
        <div className="position-relative">
            <div style={{ zIndex: 1 }} className="position-absolute top-15">
                <span className="fs-8 text-primary cursor-pointer"
                    onClick={() => tableRef.current?.instance.clearFilter()}
                >
                    Clear Filter
                </span>
            </div>
            <DataGrid
                id="jobTable"
                keyExpr="id"
                onRowPrepared={(e) => { e.rowElement.classList.add("data-grid-row"); }}
                dataSource={data}
                showBorders={false}
                showColumnLines={false}
                ref={tableRef}
                showRowLines={true}
                hoverStateEnabled={true}
                height={'calc(50vh - 60px)'}
                allowColumnResizing={true}
                selection={{ mode: 'single' }}
                onCellClick={toJobDetail}
                onEditorPreparing={setDxFilterPlaceholder}
                onExporting={(e) => onExporting(e, "Jobs")}
            >
                <Export enabled />
                <FilterRow showOperationChooser={false} visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} />
                <Scrolling showScrollbar="always" mode="virtual" rowRenderingMode="virtual" />
                <Paging defaultPageSize={50} />
                <Summary>
                    <TotalItem cssClass='absolute-right' displayFormat="Total Jobs: {0}" column='hostPropertyAddress' summaryType='count' />
                </Summary>

                <Column dataField="hostPropertyAddress" minWidth={450} caption="Property" cssClass='cls' />
                <Column dataField="scheduledStart" caption='Scheduled Start' dataType='date' selectedFilterOperation='between' format={config.date_time_format_dev_extreme} calculateCellValue={calculateScheduledStart} minWidth={180} cssClass='cls'  >
                    <HeaderFilter dataSource={getDateFilter('scheduledStart')} />
                </Column>
                <Column dataField="jobStatusTypeName" alignment='center' caption="Status" cellRender={displayStatusType} minWidth={250} cssClass='cls' />

                <Column dataField="startedOn" caption='Started at' dataType='date' format={config.date_time_format_dev_extreme} selectedFilterOperation='between' calculateCellValue={calculateStartedOn} minWidth={180} cssClass='cls' >
                    <HeaderFilter dataSource={getDateFilter('startedOn')} />

                </Column>

                <Column dataField="scheduledFinish" caption='Scheduled Finish' dataType='date' selectedFilterOperation='between' format={config.date_time_format_dev_extreme} calculateCellValue={calculateScheduledFinish} minWidth={180} cssClass='cls'>
                    <HeaderFilter dataSource={getDateFilter('scheduledFinish')} />

                </Column>

                <Column dataField="finishedOn" caption='Finished at' selectedFilterOperation='between' dataType='date' format={config.date_time_format_dev_extreme} calculateCellValue={calculateFinishedOn} minWidth={190} cssClass='cls'>
                    <HeaderFilter dataSource={getDateFilter('finishedOn')} />

                </Column>
                <Column dataField="hostPropertyCityName" caption="City" minWidth={150} cssClass='cls' />
                <Column dataField="hostPropertyCountryName" caption="Country" minWidth={200} cssClass='cls' />
                <Column dataField="hostPropertyStateName" caption="State" minWidth={200} cssClass='cls' />
            </DataGrid>

        </div>

    )
}

export default JobTable;